module.exports = __webpack_public_path__ + "static/img/pro7_tab2.c4e9a6f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/introduceFour/pro7_tab2.jpg
// module id = n3Zi
// module chunks = 171